import request from "superagent";
import { getAuthHeader } from "./superagent";
import { logError } from "@src/appV2/lib/analytics";

export const getFSSProfilePicDistributionURL = async (
  workerId: string
  // @ts-expect-error TODO(typecheck-unify): TS7030 Not all code paths return a value.
): Promise<string | undefined> => {
  if (!workerId) {
    return;
  }

  try {
    const distributionURL = await request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/agentProfile/${workerId}/profile-image-distribution-url`)
      .set(await getAuthHeader());
    return distributionURL.body?.distribution_url;
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error?.status !== 404) {
      logError("Error fetching profile pic url", {
        error,
        metadata: {
          workerId,
        },
      });
    }
  }
};
